import * as swcHelpers from '@swc/helpers';
import { useBrPageContext } from '../context/context.js';

function useBloomreachPageRoutes() {
    const page = useBrPageContext();
    if (!page) {
        return {
            routes: {}
        };
    }
    const pageRoutes = page === null || page === void 0 ? void 0 : page.getComponent().getModels().routes;
    if (!pageRoutes) {
        return {
            routes: {}
        };
    }
    // In the new version of bloomreach in preview mode the params that
    // are added by the bloomreach API can cause issues for the root routes sometimes
    // because these are base routes that are usually joined with other paths
    let cleanedRoutes = pageRoutes;
    if (page.isPreview()) {
        cleanedRoutes = Object.keys(pageRoutes).reduce((acc, key)=>{
            const route = pageRoutes[key].split('?')[0];
            return swcHelpers.objectSpread({}, acc, {
                [key]: route !== null && route !== void 0 ? route : ''
            });
        }, {});
    }
    return {
        routes: cleanedRoutes
    };
}

export { useBloomreachPageRoutes };
//# sourceMappingURL=use-bloomreach-page-routes.js.map
